module.exports = __webpack_public_path__ + "static/media/notes_auv_folder.f27d1271.png";